export class PoNumberReply {
    public poNumber: string = '';
}

